import { DOCUMENT } from '@angular/common';
import { Directive, Input, inject } from '@angular/core';

import { RtTextInput } from '@core/user-interface-legacy';

import type { PlaceholderConfigMap } from './placeholder';

@Directive({
  selector: '[insertPlaceholderInput]',
  exportAs: 'placeholderInput',
  standalone: true,
})
export class InsertPlaceholderInputDirective {
  private readonly doc = inject<Document>(DOCUMENT);
  public readonly input = inject(RtTextInput, { host: true, self: true });

  @Input() public placeholdersConfig: PlaceholderConfigMap = {};

  public insert(text: string): void {
    this.input.insertAtCaret(text, 'placeholder');
  }
}
